module.exports = __webpack_public_path__ + "static/media/doctor.54c4e04f.svg";